import { render } from "./FailedLoginsTable.vue?vue&type=template&id=0af9dad3&scoped=true"
import script from "./FailedLoginsTable.vue?vue&type=script&lang=js"
export * from "./FailedLoginsTable.vue?vue&type=script&lang=js"

import "./FailedLoginsTable.vue?vue&type=style&index=0&id=0af9dad3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af9dad3"]])

export default __exports__